/**
 * Usato all'interno del Template Service. Attenzione il valore è quello RICHIESTO dal BK e non è mappato se non qui
 */
export enum TemplateDocumentType {
  TREATMENT_RESPONSIBLE = 'treatment-responsible',
  TREATMENT_SUB_RESPONSIBLE = 'treatment-sub-responsible',
  TREATMENT_HOLDER = 'treatment-holder',
  GLOBAL_MEASURE_CHECK = 'global-measure-check',
  APP_ASSESSMENT = 'app-assessment',
  DPIA = 'dpia',
  TREATMENT_PROJECT = 'treatment-project',
  COVID_ASSESSMENT = 'covid-assessment',
  AI_ASSESSMENT = 'ai-assessment',
  LIA = 'lia'
}
